import { Component } from "@angular/core";
import { Platform } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { TranslateService } from "@ngx-translate/core";

import { HomePage } from "../pages/home/home";
@Component({
  templateUrl: "app.html"
})
export class AppComponent {
  rootPage: any = HomePage;

  constructor(
    platform: Platform,
    translate: TranslateService,
    statusBar: StatusBar,
    splashScreen: SplashScreen
  ) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
      translate.setDefaultLang("fr");
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts